import styles from "./style.module.scss";
import clsx from "clsx";
import { Link } from "react-router-dom";

export const TextSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h3>予約関連</h3>
        <ul>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>予約はいつからできますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>3ヶ月前からの予約が可能です</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>宿泊予約はどこからできますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p className={styles.flex}>
                  こちらの<Link to="/reservation">予約ページ</Link>
                  からできます。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>体験予約はどこからできますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p className={styles.flex}>
                  宿泊予約と同じ<Link to="/reservation">予約ページ</Link>
                  で、体験を一緒にご予約ください。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>料金はどのようになっていますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  一棟貸切料金で20,000円（1〜2名の場合）もしくは25,000円（3〜4名）となっています。
                </p>
                <p className={styles.flex}>
                  詳しくは
                  <Link to="/facility-overview">施設概要</Link>
                  をご覧ください。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>決済方法は何がありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  クレジットカード、銀行振込が可能です。
                  <br />
                  決済情報は、予約申し込み後にメールでお知らせいたします。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>
                  チェックイン前、チェックアウト後の荷物の預りは可能ですか？
                </p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  事前に相談いただいた場合は可能です。予約時もしくは予約後にお問い合わせください。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>チェックイン前や、チェックイン後に車は止められますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  事前に相談いただいた場合は可能です。予約時もしくは予約後にお問い合わせください。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>予約時に入力した宿泊者名／到着時間等を変更できますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>その場合は事前にご相談ください。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>キャンセルポリシーは？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  以下のようになっています。
                  <br />
                  <br />
                  宿泊日の5日前まで：無料
                  <br />
                  宿泊日の5日前から2日前まで：宿泊料金の50%
                  <br />
                  宿泊日の2日前以降：宿泊料金の100%
                  <br />
                  <br />
                  体験予約についても同様です。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>長期滞在への対応はしていますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>対応可能な場合もあります。</p>
                <p className={styles.flex}>
                  <Link to="/reservation">お問い合わせフォーム</Link>
                  までぜひご相談ください。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>チェックイン、チェックアウトは何時ですか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  以下の通りです。
                  <br />
                  チェックイン：15〜21時
                  <br />
                  チェックアウト：10時
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>チェックインはどのような方法ですか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  無人チェックインとなります。チェックイン方法は予約完了後にメールでお伝えいたします。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>チェックアウトを遅らせることは出来ますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  事前に相談いただいた場合は可能です。チェックアウト前日までにご相談ください。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>門限はありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  チェックイン後の門限は特にありませんが、チェックインは当日21時までにお願いいたします。
                </p>
              </div>
            </div>
          </li>
        </ul>

        <h3 className={styles.margin}>駐車、車関連について</h3>
        <ul>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>駐車場はありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>敷地内にあります。</p>
                <p className={styles.flex}>
                  駐車場の場所は<Link to="/access">アクセス</Link>
                  をご確認ください。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>レンタカーは借りられますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  石巻マリンヴィレッジでのレンタカーサービスは実施していませんが、石巻駅や石巻マリンヴィレッジから徒歩圏内のレンタカー屋さんをご利用いただけます。
                </p>
                <br />
                <br />
                <p>
                  <a
                    href="https://www.japan-csa.org/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    日本カーシェアリング協会
                  </a>
                  <span>
                    宮城県石巻市駅前北通り1丁目5-23（石巻駅より徒歩10分）
                  </span>
                </p>
                <br />
                <br />
                <p>
                  <a
                    href="https://www.japan-csa.org/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    駅レンタカー　石巻営業所
                  </a>
                  <span>宮城県石巻市穀町56-2（石巻駅を出てすぐ）</span>
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>車はあった方がいいですか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  石巻マリンヴィレッジには路線バスでアクセスでき、徒歩圏内で買い物なども楽しめます。ただ、自家用車やレンタカーがあった方が楽しみの幅が広がるのは間違いありません。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>タクシーを呼ぶことはできますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  お客様ご自身で呼んでいただくことを条件として可能です。以下のようなタクシー会社があります。
                  石巻タクシー㈲ / ℡:0225-22-3165 東宝タクシー㈱ /
                  ℡:0225-22-5101 宮城交通㈱ / ℡:0120-752-652 石巻観光タクシー㈱
                  / ℡:0225-95-2311
                </p>
                <br />
                <br />
                <p className={styles.flex}>
                  石巻タクシー㈲ / ℡:　<a href="tel:0225223165">0225-22-3165</a>
                </p>
                <p className={styles.flex}>
                  東宝タクシー㈱ / ℡:　<a href="tel:0225225101">0225-22-5101</a>
                </p>
                <p className={styles.flex}>
                  宮城交通㈱ / ℡:　<a href="tel:0120752652">0120-752-652</a>
                </p>
                <p className={styles.flex}>
                  石巻観光タクシー㈱ / ℡:　
                  <a href="tel:0225952311">0225-95-2311</a>
                </p>
              </div>
            </div>
          </li>
        </ul>

        <h3 className={styles.margin}>施設、設備関連</h3>
        <ul>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>客室にテレビはありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>ありません。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>インターネットは使えますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>無料のフリーWi-fiが利用いただけます。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>リモートワークや勉強ができる環境はありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>宿泊棟内で可能です。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>タオルの貸し出しはありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>バスタオル、フェイスタオルを人数分用意しております。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>シャンプー、ボディソープはありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>浴室にあります。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>お風呂やトイレはついていますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>ついています。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>洗濯機はありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>あります。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>ヘヤードライヤーは用意されていますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>あります。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>喫煙できますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>屋外でのみ可能です。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>部屋で宿泊者以外と面会は出来ますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>予約者以外が宿泊をされないことを条件として可能です。</p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>
                  屋外の共用キッチンなどを使いたい場合はどのようにすればいいですか？
                </p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  ご自由にお使いいただけますが、住宅の入居者様も使いますので、協力してご利用ください。
                </p>
              </div>
            </div>
          </li>
        </ul>

        <h3 className={styles.margin}>周辺情報</h3>
        <ul>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>近くにコンビニやスーパーはありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  徒歩10分圏内にあります。
                  <br />
                  <br />
                  コンビニ：ローソン石巻青葉店（徒歩10分）
                  <br />
                  スーパーマーケット：ヨークベニマル 中浦店（徒歩5分）
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>近くに飲食店はありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  徒歩10分圏内にあります。
                  <br />
                  <br />
                  ▼おすすめ
                  <br />
                  ラーメン屋：三代目 浜八道（徒歩5分）
                  <br />
                  中華料理：南京飯店（徒歩5分）
                  <br />
                  焼肉屋：焼肉うしのまき石巻店（徒歩10分）
                  <br />
                  海鮮料理：ひらつか（徒歩10分）
                  <br />
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>近くに温泉はありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  少し離れていますが、30分ほど歩くと「天然温泉
                  元気の湯」があります。車だと5分ほどで行くことができます。
                </p>
              </div>
            </div>
          </li>
          <li>
            <div className={styles.box}>
              <div className={styles.circle}>Q</div>
              <div className={styles.textBox}>
                <p>石巻市内でおすすめの観光スポットはありますか？</p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={clsx(styles.circle, styles.answer)}>A</div>
              <div className={styles.textBox}>
                <p>
                  一部ですがおすすめの観光スポットを紹介します。
                  <br />
                  <br />
                  石ノ森萬画館：著名な漫画家石ノ森章太郎の作品をテーマにした実物大のフィギュア、アニメを展示する博物館
                  <br />
                  石巻市震災遺構
                  門脇小学校：震災時に津波被害に遭った小学校の旧校舎を活用した震災遺構施設
                  <br />
                  日和山公園：市内を一望でき、津波の避難場所としても知られる小高い山
                  <br />
                  IRORI石巻：石巻市内の人と情報が集まり、聞けば面白い情報をたくさん教えてくれるカフェ兼コミュニティスペース
                  <br />
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};
